<template>
  <div>
    <ul class="select-option" style="overflow: hidden">
      <li>
        <span class="select-title">事件ID：</span>
        <el-input
          v-model="caseId"
          clearable
          placeholder="请输入事件ID"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">处理人姓名：</span>
        <el-input
          v-model="handler"
          clearable
          placeholder="请输入申请人姓名"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">任务分配时间：</span>
        <el-date-picker
          v-model="startTime"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
      </li>
      <li>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </li>
      <li style="display: block; width: 100%">
        <el-button type="primary" icon="iconfont icon-chakanxiangqing" @click="seecase">
          查看详情
        </el-button>
      </li>
    </ul>
    <el-table
      ref="multipleTable"
      border
      tooltip-effect="dark"
      :data="tableData.records"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      class="table-block"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="50"
        align="center"
      />

      <el-table-column type="selection" width="60" align="center" />
      <el-table-column label="事件id" prop="caseId" width="150" align="center" />
      <el-table-column prop="reportTime" label="报案时间" width="180" align="center" />
      <el-table-column prop="startTime" label="任务开始时间" width="180" align="center" />
      <el-table-column prop="endTime" label="任务完成时间" width="180" align="center" />
      <el-table-column
        prop="recRealName"
        label="受助人姓名"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="productName"
        label="所属计划"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="status"
        label="任务状态"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="handler"
        label="处理人"
        align="center"
        show-overflow-tooltip
      />
    </el-table>
    <!-- 页码 -->
    <div class="pagination-block">
      <el-pagination
        :page-size="tableData.size"
        :current-page="pageIndex"
        background
        layout="total, prev, pager, next, jumper"
        :total="tableData.total"
        @current-change="pageChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },

      // 查询列表的参数
      accessRole: 'ACCESS_MINE', // 角色权限 ACCESS_ALL：全部，ACCESS_MINE：自己
      limit: 10, // 分页列表长度
      pageIndex: 1, // 页码
      caseId: '', // 案件编号
      handler: '', // 处理人
      startTime: '', // 开始时间
      caseFlow: '', // 所属流程（已废除）

      tableData: {},
      selectRows: [],
      // 所属流程
      processList: [
        { code: 101020, name: '【公估-回访】' },
        { code: 100020, name: '【初审回访客诉子任务】' },
        { code: 100513, name: '【缴费回访客诉子任务】' },
        { code: 100599, name: '【是否去调查子任务】' },
        { code: 103001, name: '【确认结果客诉子任务】' },
        { code: 101520, name: '【补资料回访子任务】' }
      ]
    }
  },

  created() {
    const _this = this
    _this.$emit('setCurrentMenu', '我的调查任务')

    // 获取本地缓存数据
    const currentMyResearchTaskSearchData = JSON.parse(
      localStorage.getItem('currentMyResearchTaskSearchData')
    )
    if (currentMyResearchTaskSearchData) {
      _this.accessRole = currentMyResearchTaskSearchData.accessRole
      _this.limit = currentMyResearchTaskSearchData.limit
      _this.pageIndex = currentMyResearchTaskSearchData.pageIndex
      _this.caseId = currentMyResearchTaskSearchData.caseId
      _this.handler = currentMyResearchTaskSearchData.handler
      _this.startTime = currentMyResearchTaskSearchData.startTime
      _this.caseFlow = currentMyResearchTaskSearchData.caseFlow
    }
    _this.getAdjustingList(
      _this.caseId,
      _this.handler,
      _this.startTime,
      _this.accessRole,
      _this.caseFlow,
      _this.pageIndex
    )
  },

  methods: {

    /**
     * 公估子任务-列表
     * @param {string} caseId 案件编号
     * @param {string} handler 处理人
     * @param {string} startTime 开始时间
     * @param {string} accessRole 角色权限 ACCESS_ALL：全部，ACCESS_MINE：自己
     * @param {string} caseFlow 所属流程
     * @param {number} page 页码
     */
    async getAdjustingList(
      caseId,
      handler,
      startTime,
      accessRole,
      caseFlow,
      page = 1
    ) {
      const _this = this
      const { limit } = _this
      try {
        const { data: result } = await _this.axios.get(
          _this.homePath() + '/case-task/adjustingList',
          {
            params: {
              accessRole,
              page,
              caseId,
              handler,
              startTime,
              caseFlow,
              limit
            }
          }
        )
        if (result && result.status === '000000') {
          _this.tableData = result.page
        } else {
          _this.$alert((result && result.message) || '服务器繁忙，请稍后重试', '提示')
        }
      } catch (error) {
        console.log('公估子任务-列表-请求失败', error)
      }
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    /**
     * 搜索
     */
    search() {
      this.pageIndex = 1
      this.getAdjustingList(
        this.caseId,
        this.handler,
        this.startTime,
        this.accessRole,
        this.caseFlow
      )
    },

    /**
     * 表格组件-当某一行被点击时会触发该事件
     */
    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },

    /**
     * 表格组件-行的 style 的回调方法
     */
    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    /**
     * 表格组件-行的 className 的回调方法
     */
    rowClassName({ row }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    /**
     * 表格组件-当选择项发生变化时会触发该事件
     */
    selectionChange(rows) {
      this.selectRows = rows
    },

    /**
     * 查看详情
     */
    seecase() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      // 缓存数据
      const currentMyResearchTaskSearchData = {
        accessRole: vm.accessRole,
        limit: vm.limit,
        pageIndex: vm.pageIndex,
        caseId: vm.caseId,
        handler: vm.handler,
        startTime: vm.startTime,
        caseFlow: vm.caseFlow
      }
      localStorage.setItem(
        'currentMyResearchTaskSearchData',
        JSON.stringify(currentMyResearchTaskSearchData)
      )

      vm.onNavsToCaseDetailV2()
    },

    /**
     * 跳转页面-案件详情页
     */
    onNavsToCaseDetailV2() {
      const vm = this
      const { selectRows } = vm
      vm.$router.push({
        path: '/index/caseDetailV2/' + selectRows[0].caseCode,
        query: {
          from: 'myResearchTask',
          taskCode: selectRows[0].taskCode,
          taskVersion: selectRows[0].taskVersion
        }
      })
    },

    /**
     * 分页组件-currentPage 改变时会触发
     * @param {number} page  页码
     */
    pageChange(page) {
      this.pageIndex = page
      this.getAdjustingList(
        this.caseId,
        this.handler,
        this.startTime,
        this.accessRole,
        this.caseFlow,
        page
      )
    }
  }
}
</script>

<style scoped lang="scss">
.table-block {
  width: 100%;
  margin-top: 15px;
}
.pagination-block {
  text-align: center;
  margin-top: 25px;
}
</style>
